"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Tab: {
      cursor: 'pointer',
      marginRight: 10,
      padding: [9, 13],
      backgroundColor: theme['$background-alt-color'],
      fontFamily: theme['$font-default'],
      fontSize: 12,
      color: theme['$placeholder-color'],
      lineHeight: '14px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      borderRadius: 6,
      userSelect: 'none',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: theme['$panel-background-color'],
        color: theme['$text-color']
      }
    },
    ActiveTab: {
      backgroundColor: theme['$menu-active-background-color'],
      zIndex: 2,
      color: theme['$text-color'],
      cursor: 'default',
      '&:hover': {
        backgroundColor: theme['$menu-active-background-color'],
        color: theme['$text-color']
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map